import React from "react";
import { useLocation, Redirect } from "react-router-dom";
import PageFrame from "./PageFrame";

const FramePage = () => {
  let location = useLocation();
  const frameUrl = location.search.split("?url=")?.[1];
  return (
    <>
      {!frameUrl && <Redirect to="/" />}
      <PageFrame source={frameUrl} />
    </>
  );
};

export default FramePage;
